/* eslint-disable import/prefer-default-export */

import { createAction } from '@reduxjs/toolkit'
import { IMetric, Ranking, MetricValue, ChartType, MetricType } from 'types'

export const setTool = createAction<{ tool: 'AIVR' | 'AIMOT' }>('AIMetricOT/setTool')
export const setRanking = createAction<{ ranking: Ranking }>('AIMetricOT/setRanking')
export const setCountryType = createAction<{ countryType: Ranking }>('AIMetricOT/setCountryType')
export const setCountry = createAction<{ country: string }>('AIMetricOT/setCountry')
export const setComparingCountries = createAction<{ countries: Array<string> }>('AIMetricOT/setComparingCountries')
export const setMetric = createAction<{
  metric: {
    rad: IMetric
    eco: IMetric
    edu: IMetric
    div: IMetric
    pol: IMetric
    pub: IMetric
    rai: IMetric
    inf: IMetric
  }
}>('AIMetricOT/setMetric')
export const setMetricOTType = createAction<{ metricType: MetricType }>('AIMetricOT/setMetricOTType')
export const setMetricOTValue = createAction<{ metricValue: MetricValue }>('AIMetricOT/setMetricOTValue')
export const setMetricOTChartType = createAction<{ chartType: ChartType }>('AIMetricOT/setMetricOTChartType')
export const setWorldmapYear = createAction<number>('AIMetricOT/setWorldmapYear')
